import { i as x, n as h } from "./abstract-base-CdeHT0x1.js";
import { B as m } from "./chart-base-DQP-2wFc.js";
import { w as b, m as d } from "./lifecycle-decorators-VlFt_asj.js";
import { c as f } from "./propertyConverters-BCogXvUC.js";
const u = x`.highcharts-axis-title{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.highcharts-axis-line,.highcharts-grid-line,.highcharts-plot-line.origin-line,.highcharts-tick{stroke-width:var(--beacon-system-width-border-mini)}.highcharts-graph{stroke-width:var(--beacon-system-width-border-normal)}.highcharts-grid-line,.highcharts-axis-line{stroke:var(--beacon-component-data-viz-color-border-minor)}.highcharts-navigator-xaxis .highcharts-grid-line{stroke:var(--beacon-component-data-viz-color-border-minor);stroke-width:var(--beacon-system-width-border-mini)}.highcharts-plot-line.origin-line,.highcharts-tick{stroke:var(--beacon-component-data-viz-color-border-major)}.highcharts-plot-band.negative-area{fill:var(--beacon-system-color-background-1);fill-opacity:1}`;
var y = Object.defineProperty, v = Object.getOwnPropertyDescriptor, o = (n, e, t, i) => {
  for (var a = i > 1 ? void 0 : i ? v(e, t) : e, r = n.length - 1, s; r >= 0; r--)
    (s = n[r]) && (a = (i ? s(e, t, a) : s(a)) || a);
  return i && a && y(e, t, a), a;
};
function L(n) {
  let e = class extends n {
    constructor() {
      super(...arguments), this.yAxisLabel = "", this.xAxisLabel = "";
    }
    static get chartAreaStyles() {
      return u;
    }
    get totalChartCategories() {
      var a, r, s, c, g;
      const t = (r = (a = this.chart) == null ? void 0 : a.series) == null ? void 0 : r.map(
        (l) => {
          var p;
          return (p = l == null ? void 0 : l.data) == null ? void 0 : p.length;
        }
      );
      if (!(t != null && t.length)) return;
      const i = Math.max(...t);
      return (g = (c = (s = this.categories) == null ? void 0 : s.length) != null ? c : i) != null ? g : void 0;
    }
    willUpdate(t) {
      var i;
      (i = super.willUpdate) == null || i.call(this, t), t.has("xAxisLabel") && this.updateChart({ xAxis: { title: { text: this.xAxisLabel } } }), t.has("yAxisLabel") && this.updateChart({ yAxis: { title: { text: this.yAxisLabel } } }), t.has("categories") && this.updateChart({ xAxis: { categories: this.categories } }), t.has("chart") && this._addPlotBands(), t.has("stacking") && this.updateChart({
        plotOptions: { series: { stacking: this.stacking } }
      });
    }
    // Apply the negative area of the chart after we can access the min of the y axis
    _addPlotBands() {
      var t;
      this.updateChart({
        yAxis: {
          plotBands: [
            {
              className: "negative-area",
              from: 0,
              to: (t = this.chart) == null ? void 0 : t.yAxis[0].min
            }
          ]
        }
      });
    }
    get localComponentOptions() {
      return m.createChartOptions(super.localComponentOptions, {
        xAxis: {
          categories: this.categories,
          labels: {
            y: 24
          },
          tickLength: 4,
          title: {
            margin: 16,
            text: this.xAxisLabel
          }
        },
        yAxis: {
          labels: {
            formatter() {
              const { value: t } = this;
              return typeof t == "number" ? t < 1e3 ? `${t}` : t < 1e6 ? `${t / 1e3}k` : `${Math.round(t / 1e4) / 100}M` : t;
            }
          },
          plotLines: [
            // Origin Line
            {
              className: "origin-line",
              value: 0,
              zIndex: 5
              // Layers it over the other grid lines
            }
          ],
          title: {
            margin: 16,
            text: this.yAxisLabel
          }
        }
      });
    }
    getTooltipClasses() {
      var t;
      return `beacon-chart-tooltip ${this.colorOrder} ${this.type} ${((t = this.series) == null ? void 0 : t.length) === 1 ? "single-series-chart" : ""} ${this.stacking ? "stacked-chart" : ""}`.trim();
    }
  };
  return o([
    h({ attribute: "y-axis-label" })
  ], e.prototype, "yAxisLabel", 2), o([
    h({ attribute: "x-axis-label" })
  ], e.prototype, "xAxisLabel", 2), o([
    h({
      converter: (t) => f(t, ",")
    })
  ], e.prototype, "categories", 2), o([
    h({ reflect: !0 })
  ], e.prototype, "stacking", 2), o([
    b("series")
  ], e.prototype, "_addPlotBands", 1), e = o([
    d("ChartArea")
  ], e), e;
}
export {
  L as C
};
